module.exports = __webpack_public_path__ + "img/gys_28@2x.e703934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_28@2x.png
// module id = 2IYT
// module chunks = 0